import { Box } from "@styled-system/jsx";
import { useEffect, useState } from "react";

type Props = {
  Animation: any;
  className?: string;
};

export default function Lottie({ Animation, className }: Props) {
  //not optimal
  const [PlayerComponent, setPlayerComponent] = useState<any>(null);

  useEffect(() => {
    import("@lottiefiles/react-lottie-player").then((module) => {
      setPlayerComponent(() => module.Player);
    });
  }, []);

  if (!PlayerComponent) return null;

  return (
    <Box className={className}>
      <PlayerComponent autoplay src={Animation} loop />
    </Box>
  );
}
